// removed by extract-text-webpack-plugin
module.exports = {"label":"src-components-DateRangeForm----DateRangeForm-module---label---29Mfc","dateWrapper":"src-components-DateRangeForm----DateRangeForm-module---dateWrapper---1cwbP","quantityWrapper":"src-components-DateRangeForm----DateRangeForm-module---quantityWrapper---2lgk2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DateRangeForm/DateRangeForm.module.scss
// module id = 474
// module chunks = 137591856104208 208175303390894